import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 1.75H5.86852L4.375 0.256489C4.29404 0.174884 4.19767 0.110185 4.09149 0.0661539C3.98531 0.0221227 3.87143 -0.000362818 3.75648 4.42693e-06H0.875C0.642936 4.42693e-06 0.420376 0.0921916 0.256282 0.256286C0.0921872 0.42038 0 0.64294 0 0.875004V8.78391C0.000289401 9.00689 0.0889973 9.22066 0.24667 9.37833C0.404343 9.53601 0.618111 9.62471 0.841094 9.625H10.5487C10.7677 9.62471 10.9778 9.53756 11.1327 9.38266C11.2876 9.22775 11.3747 9.01774 11.375 8.79868V2.625C11.375 2.39294 11.2828 2.17038 11.1187 2.00629C10.9546 1.84219 10.7321 1.75 10.5 1.75ZM0.875 0.875004H3.75648L4.63148 1.75H0.875V0.875004ZM10.5 8.75H0.875V2.625H10.5V8.75Z",
		fill: "currentColor"
	})
});
export default SvgFolderIcon;
